import type { TFunction } from "i18next";

/**
 * "Aviso de cierre · hace N días" — shown under the status badge for a tenant
 * that has been emailed the inactivity closure notice.
 *
 * The operator needs the age, not just the fact: the platform delete endpoint
 * refuses removal until the 7-day notice period has elapsed, so "sent 2 days
 * ago" and "sent 3 weeks ago" mean different things about whether the Eliminar
 * action will go through.
 *
 * Shared by the desktop table and the mobile card so the two cannot drift.
 */
export function closureNoticeLabel(
  sentAt: string | null | undefined,
  t: TFunction,
): React.ReactNode {
  if (!sentAt) return null;
  const sent = new Date(sentAt).getTime();
  if (Number.isNaN(sent)) return null;

  const days = Math.floor((Date.now() - sent) / (24 * 60 * 60 * 1000));
  const age =
    days <= 0
      ? t("tenants.page.closureNoticeToday", "hoy")
      : days === 1
        ? t("tenants.page.closureNoticeOneDay", "hace 1 día")
        : t("tenants.page.closureNoticeDays", `hace ${days} días`);

  return (
    <p className="mt-1 text-xs text-muted-foreground">
      {t("tenants.page.closureNotice", "Aviso de cierre")} · {age}
    </p>
  );
}
